import Toaster from 'toastr';
import Messages from '../configurations/messages'; 
import * as types from './actionTypes';
import UserApi from '../api/UserApi';

export function loadUserPermissionsSuccess(permissions) {
    return { type: types.LOAD_USER_PERMISSIONS_SUCCESS, permissions };
}

export function loadUserPermissions() {
    return function (dispatch) {
        
        return UserApi.getUserPermissions().then(response => {
            let permissions = response.data.map(auth => { return auth.authority; });
            dispatch(loadUserPermissionsSuccess(permissions));
        }).catch(error => {
            Toaster.error(Messages.LOAD_PERMISSIONS_ERROR);
            console.log(error);
            dispatch(loadUserPermissionsSuccess(null));

        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/permissionsAction.js